<script>
import Error from './Error.vue';

export default {
  name: 'error-boundary',
  data: () => ({ erreur: null }),
  errorCaptured(err, vm, info) {
    this.erreur = `${err.stack}\n\nfound in ${info} of component`;
    return false;
  },
  render(h) {
    if (this.erreur) {
      // eslint-disable-next-line
      console.log(`Erreur:${this.erreur}`);
      return h(Error, this.erreur);
    }
    // ignoring edge cases for the sake of demonstration
    return this.$slots.default[0];
  },
};
</script>

<style scoped>

</style>
